import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, Card, LoadingState, ErrorState, Pill } from "@/components/common/UI";
import { roleBadgeClass, roleLabel } from "@/lib/auth";
import { fmtDateTime } from "@/lib/format";

const ACTION_TONE = {
    CREATE: "emerald", UPDATE: "blue", DELETE: "red",
    APPROVE: "emerald", REJECT: "red", SUBMIT: "amber",
    RATE_CHANGE: "copper", LOGIN: "slate",
};

export default function AuditLog() {
    const [rows, setRows] = useState(null);
    const [error, setError] = useState("");

    const load = () =>
        api.get("/audit-log?limit=200").then((r) => setRows(r.data)).catch((e) => setError(formatApiError(e)));
    useEffect(() => { load(); }, []);

    return (
        <div data-testid="audit-log-page">
            <PageHeader
                eyebrow="ADMINISTRATION"
                title="Audit Log"
                subtitle="Every meaningful action (rate changes, approvals, master data edits) captured with actor, role, and timestamp."
            />
            {error && <ErrorState message={error} onRetry={load} />}
            {!error && rows === null && <LoadingState />}
            {rows && rows.length === 0 && <div className="text-sm text-slate-500">No audit entries yet.</div>}
            {rows && rows.length > 0 && (
                <Card>
                    <table className="w-full table-rowhover">
                        <thead>
                            <tr className="border-b border-slate-200 bg-slate-50/60">
                                <th className="eyebrow text-left py-3 px-4">When</th>
                                <th className="eyebrow text-left py-3 px-4">Actor</th>
                                <th className="eyebrow text-left py-3 px-4">Role</th>
                                <th className="eyebrow text-left py-3 px-4">Action</th>
                                <th className="eyebrow text-left py-3 px-4">Entity</th>
                                <th className="eyebrow text-left py-3 px-4">Summary</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => (
                                <tr key={r.id} className="border-b border-slate-100">
                                    <td className="py-2.5 px-4 text-[12px] font-mono tabular-nums text-slate-500 whitespace-nowrap">{fmtDateTime(r.timestamp)}</td>
                                    <td className="py-2.5 px-4 text-[13px] font-medium">{r.user_name}</td>
                                    <td className="py-2.5 px-4"><span className={`pill ${roleBadgeClass(r.user_role)}`}>{roleLabel(r.user_role)}</span></td>
                                    <td className="py-2.5 px-4"><Pill tone={ACTION_TONE[r.action] || "slate"}>{r.action.replace("_", " ")}</Pill></td>
                                    <td className="py-2.5 px-4 text-[12px] font-mono">{r.entity_type}</td>
                                    <td className="py-2.5 px-4 text-[12px] text-slate-700">{r.summary}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            )}
        </div>
    );
}
